/*
 * Grippatch - modern dropdown (listbox)
 *
 * NEDEN: Native <select> acilir listesi tarayicinin isletim sistemi
 * menusudur; hicbir sekilde bicimlendirilemez ve eski duruyor.
 *
 * NASIL: Native select KALDIRILMIYOR - kaynak olarak yerinde kaliyor,
 * gorsel olarak gizleniyor. Ustune bir dugme + listbox cizilliyor.
 * Secim yapilinca deger select'e yazilip `change` olayi tetiklenir;
 * boylece mevcut is mantigi (motosiklet secici, varyant secimi,
 * koleksiyon siralamasi) hic degismeden calisir.
 *
 * JS calismazsa: `.dd--ready` sinifi hic eklenmez, native select
 * gorunur ve calisir. Yani ilerlemeli iyilestirme; kirilma yok.
 *
 * Erisilebilirlik: role=combobox + role=listbox/option, aria-expanded,
 * aria-activedescendant, klavye (yukari/asagi/Home/End/Enter/Esc/harf).
 */

const DD_ACILAN = new Set();

function ddKapatDigerleri(haric) {
  DD_ACILAN.forEach((d) => {
    if (d !== haric) d.kapat();
  });
}

/* Secenek rozeti (marka isareti).
 *
 * `<option>` uzerinde `data-harf` / `data-renk` / `data-logo` varsa adin
 * soluna kucuk yuvarlak bir isaret konur. `data-logo` gercek bir logo
 * dosyasinin adresi; yuklenemezse (dosya silinmis/yol degismis) sessizce
 * monogram harfe dusulur - kirik gorsel ikonu cikmaz.
 *
 * Rozet verisi olmayan dropdown'lar (varyant secimi, koleksiyon siralamasi)
 * bundan hic etkilenmez: dataset bos oldugu icin null doner.
 */
function ddRozet(o) {
  if (!o) return null;
  const harf = o.dataset.harf || '';
  const logo = o.dataset.logo || '';
  /* Renkli surumun adresi indeksten gelir. GELMEZSE beyaz surumun adindan
     TURETILIR: `.../marka-honda.png?v=abc` -> `.../marka-honda-renkli.png`.
     Neden: indeks eski bir surumden (onbellek, surum 2 bicimi) geliyorsa
     `logoRenkli` bos kaliyor, renkli gorsel hic basilmiyor ve acik zeminde
     beyaz siluet kayboluyordu (musteri 2026-08-28/29 bildirimi; canli sayfa
     olculdugunde dogruydu, yani hata istemci durumunda olusuyor).
     Turetilen adreste surum damgasi YOK - dosya bulunamazsa `onerror`
     kaldiriyor, CSS emniyeti (dropdown.css sonu) devreye giriyor. */
  let logoRenkli = o.dataset.logoRenkli || '';
  if (!logoRenkli && logo) {
    logoRenkli = logo.replace(/(\/marka-[^/?]+?)(\.[a-z]+)(\?.*)?$/i, '$1-renkli$2');
    if (logoRenkli === logo) logoRenkli = '';
  }
  if (!harf && !logo) return null;

  const el = document.createElement('span');
  el.className = 'dd__logo';
  el.setAttribute('aria-hidden', 'true');
  if (o.dataset.renk) el.style.setProperty('--dd-logo-renk', o.dataset.renk);

  const harfeDus = () => {
    el.textContent = harf;
    el.classList.remove('dd__logo--gorsel');
    el.dataset.uzunluk = String(harf.length);
  };

  if (logo) {
    el.classList.add('dd__logo--gorsel');
    const img = document.createElement('img');
    img.className = 'dd__logo-img dd__logo-img--beyaz';
    img.src = logo;
    img.alt = '';
    img.loading = 'lazy';
    img.addEventListener('error', () => {
      img.remove();
      if (harf) harfeDus();
      else el.remove();
    });
    el.appendChild(img);
    /* Acik kip surumu: HANGISININ gorunecegini CSS secer (bkz dropdown.css
       `.dd__logo-img--renkli`). JS'in kipi bilmesi GEREKMIYOR - kullanici
       gece/gunduz dugmesine bastiginda ek kod calismadan dogru logo gelir. */
    if (logoRenkli) {
      const im2 = document.createElement('img');
      im2.className = 'dd__logo-img dd__logo-img--renkli';
      im2.src = logoRenkli;
      im2.alt = '';
      im2.loading = 'lazy';
      im2.addEventListener('error', () => im2.remove());
      el.appendChild(im2);
    }
  } else {
    harfeDus();
  }
  return el;
}

function initDropdown(sarmal) {
  const select = sarmal.querySelector('select');
  if (!select || select.multiple) return;

  const kok = document.createElement('div');
  kok.className = 'dd';

  const dugme = document.createElement('button');
  dugme.type = 'button';
  dugme.className = 'dd__btn';
  dugme.setAttribute('role', 'combobox');
  dugme.setAttribute('aria-haspopup', 'listbox');
  dugme.setAttribute('aria-expanded', 'false');

  const etiket = document.createElement('span');
  etiket.className = 'dd__val';
  dugme.appendChild(etiket);

  const ok = document.createElement('span');
  ok.className = 'dd__arw';
  ok.setAttribute('aria-hidden', 'true');
  dugme.appendChild(ok);

  const liste = document.createElement('div');
  liste.className = 'dd__list';
  liste.setAttribute('role', 'listbox');
  liste.hidden = true;

  const id = select.id || `dd-${Math.round(performance.now() * 1000)}`;
  liste.id = `${id}-liste`;
  dugme.setAttribute('aria-controls', liste.id);

  // Native select'in etiketiyle bagla (varsa)
  const dlabel = select.id && document.querySelector(`label[for="${select.id}"]`);
  if (dlabel) dugme.setAttribute('aria-labelledby', dlabel.id || (dlabel.id = `${id}-etiket`));

  let secenekler = [];
  let odak = -1;

  const yaz = () => {
    const o = select.options[select.selectedIndex];
    etiket.textContent = o ? o.textContent.trim() : '';
    // Yer tutucu (bos deger) soluk gorunsun
    kok.classList.toggle('dd--placeholder', !select.value);

    // Kapali haldeki rozet: secili secenegin isareti dugmede de gorunur
    const eski = dugme.querySelector('.dd__logo');
    if (eski) eski.remove();
    if (select.value) {
      const r = ddRozet(o);
      if (r) dugme.insertBefore(r, etiket);
    }
  };

  const kur = () => {
    liste.innerHTML = '';
    secenekler = [];
    let rozetVar = false;
    [...select.options].forEach((o, i) => {
      const s = document.createElement('div');
      s.className = 'dd__opt';
      s.setAttribute('role', 'option');
      s.id = `${liste.id}-${i}`;
      s.dataset.deger = o.value;

      /* Metin ayri bir <span> icinde: rozet harfi (orn "H") satirin
         textContent'ine karisip klavyeyle harf atlamayi bozmasin. Harf
         aramasi `dataset.etiket` uzerinden yapiliyor. */
      const rozet = ddRozet(o);
      if (rozet) {
        s.appendChild(rozet);
        rozetVar = true;
      }
      const metin = document.createElement('span');
      metin.className = 'dd__txt';
      metin.textContent = o.textContent.trim();
      s.appendChild(metin);
      s.dataset.etiket = metin.textContent;
      if (o.disabled) s.setAttribute('aria-disabled', 'true');
      s.setAttribute('aria-selected', String(i === select.selectedIndex));
      s.addEventListener('click', () => {
        if (o.disabled) return;
        sec(i);
        kapat();
        dugme.focus();
      });
      liste.appendChild(s);
      secenekler.push(s);
    });
    // Rozetli listede secili satirin sol noktasi gereksiz - rozet zaten orada
    kok.classList.toggle('dd--rozetli', rozetVar);
    yaz();
    dugme.disabled = select.disabled;
    kok.classList.toggle('dd--disabled', select.disabled);
  };

  const sec = (i) => {
    if (i < 0 || i >= select.options.length) return;
    select.selectedIndex = i;
    secenekler.forEach((s, n) => s.setAttribute('aria-selected', String(n === i)));
    yaz();
    // Mevcut is mantigi bu olayi dinliyor - mutlaka tetiklenmeli
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const odakla = (i) => {
    if (!secenekler.length) return;
    odak = Math.max(0, Math.min(i, secenekler.length - 1));
    secenekler.forEach((s, n) => s.classList.toggle('is-focus', n === odak));
    const s = secenekler[odak];
    dugme.setAttribute('aria-activedescendant', s.id);
    s.scrollIntoView({ block: 'nearest' });
  };

  const ac = () => {
    if (select.disabled || !select.options.length) return;
    ddKapatDigerleri(api);
    liste.hidden = false;
    kok.classList.add('is-open');
    dugme.setAttribute('aria-expanded', 'true');
    odakla(select.selectedIndex < 0 ? 0 : select.selectedIndex);
    DD_ACILAN.add(api);
  };

  const kapat = () => {
    liste.hidden = true;
    kok.classList.remove('is-open');
    dugme.setAttribute('aria-expanded', 'false');
    dugme.removeAttribute('aria-activedescendant');
    secenekler.forEach((s) => s.classList.remove('is-focus'));
    DD_ACILAN.delete(api);
  };

  const api = { kapat, kur };

  dugme.addEventListener('click', () => (liste.hidden ? ac() : kapat()));

  dugme.addEventListener('keydown', (e) => {
    const acik = !liste.hidden;
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        acik ? odakla(odak + 1) : ac();
        break;
      case 'ArrowUp':
        e.preventDefault();
        acik ? odakla(odak - 1) : ac();
        break;
      case 'Home':
        if (acik) { e.preventDefault(); odakla(0); }
        break;
      case 'End':
        if (acik) { e.preventDefault(); odakla(secenekler.length - 1); }
        break;
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (acik) { sec(odak); kapat(); } else ac();
        break;
      case 'Escape':
        if (acik) { e.preventDefault(); kapat(); }
        break;
      case 'Tab':
        if (acik) kapat();
        break;
      default:
        // Harfe basinca o harfle baslayan secenege atla
        if (e.key.length === 1 && /\S/.test(e.key)) {
          const h = e.key.toLocaleLowerCase('tr');
          const bas = (acik ? odak : select.selectedIndex) + 1;
          for (let n = 0; n < secenekler.length; n++) {
            const i = (bas + n) % secenekler.length;
            const et = (secenekler[i].dataset.etiket || '').trim().toLocaleLowerCase('tr');
            if (et.startsWith(h)) {
              acik ? odakla(i) : sec(i);
              break;
            }
          }
        }
    }
  });

  document.addEventListener('click', (e) => {
    if (!kok.contains(e.target)) kapat();
  });

  // Deger/secenekler dis kaynaktan degisirse (orn secici modeli doldurunca)
  select.addEventListener('change', yaz);
  new MutationObserver(kur).observe(select, { childList: true, attributes: true, attributeFilter: ['disabled'] });

  sarmal.insertBefore(kok, select);
  kok.appendChild(dugme);
  kok.appendChild(liste);
  sarmal.classList.add('dd--ready');
  kur();
}

function initAllDropdowns() {
  document.querySelectorAll('.select').forEach((el) => {
    if (el.dataset.ddReady === '1') return;
    el.dataset.ddReady = '1';
    initDropdown(el);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllDropdowns);
} else {
  initAllDropdowns();
}

document.addEventListener('shopify:section:load', initAllDropdowns);
